import React from 'react';
import { getI18N } from 'qs-services/i18N';
import './styles.scss';

export default () => {
  const { t } = getI18N();
  return <div id={'NoCatalogueFound'}>{t('no_catalogues_found')}</div>;
};
